import {get, post, remove} from 'external/axios'
import { stringifyQueryString } from 'external/react';

export class UserService {
    async create(request) {
        return post('/user/create', request);
    }

    async update(request) {
        return post('/user/update', request);
    }

    async delete(id:string, clientId: string) {
        const locator = stringifyQueryString({id, clientId})
        return remove(`/user/delete?${locator}`)
    }

    async getUserByRoleId(role_id: number, client_id: string) {
       return get(`/user/role/${role_id}/client/${client_id}`)
    }

    async getUsersByRole(role: 'Tutor' | 'Student', client:string, detailed?: boolean) {
        const query = stringifyQueryString({client, detailed})
        return get(`/user/users/${role.toLowerCase()}?${query}`)
    }

    async packages(id:string, clientId: string) {
        const locator = stringifyQueryString({id, clientId})
        return get(`/user/packages?${locator}`)
    }

    async getHome(userId:string) {
        return get(`/user/getHomeAdmin/${userId}`)
    }
}

export const userService = new UserService();